import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme, layoutHeight, scroll }) => ({
  '&.reservationFloatingButton': {
    position: scroll ? 'fixed' : 'relative',
    right: scroll && theme.spacing(4),
    top: scroll && theme.spacing(3 + layoutHeight),
    zIndex: 1199,
    [theme.breakpoints.down('lg')]: {
      right: scroll && theme.spacing(2),
      top: scroll && theme.spacing(2 + layoutHeight),
      minHeight: 'unset',
      minWidth: 'unset',
    },
  },
  '&.staticReservationFloatingButton': {
    padding: 0,
    right: theme.spacing(2.625),
  },
  '& .RFBV2AddIcon': {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(-1),
    marginTop: theme.spacing(-0.35),
    [theme.breakpoints.down('lg')]: {
      margin: 0,
    },
  },
  '& .RFBV2Text': {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    lineHeight: '120%',
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
}));
export default StyledButton;
